import {THEME} from '@wandb/weave/common/css/color.styles';
import styled from 'styled-components';

export const Placeholder = styled.div`
  color: ${THEME.textTertiary};
`;
